import { FormInputProps } from 'brief-form'

import { SingleSelectAutoSuggestOpts } from '../SingleSelectAutoSuggest'

export type OrganisationSelectOpts = Omit<SingleSelectAutoSuggestOpts, 'listName' | 'options'> & {
  filters?: { field: string; type: string; value: string | number }[]
}

export interface OrganisationSelectProps extends FormInputProps<number | string | unknown, OrganisationSelectOpts> {}
